import { Stack } from '@mui/material';
import { memo } from 'react';

import { DetailedRestrictionPanel } from '@vp/manager/access/ui/settings/DetailedRestrictionPanel';
import { FullRestrictionPanel } from '@vp/manager/access/ui/settings/FullRestrictionPanel';
import { ProfileAccessModel, Restriction } from '@vp/profile/core/model/ProfileAccessModel';

export type AccessManagerSettingsProps = {
  access: ProfileAccessModel;
  disabled: boolean;
  onFullRestrictionToggle: () => void;
  onSectionToggle: (section: Restriction) => void;
};

export const AccessManagerSettings = memo<AccessManagerSettingsProps>(({ access, disabled, onFullRestrictionToggle, onSectionToggle }) => {
  return (
    <Stack
      gap={1}
      width={1}
      px={{ mobile: 2, tablet: 7 }}
      style={{ opacity: disabled ? 0.5 : 1 }}
      sx={{ transition: 'opacity 0.25s ease-in-out' }}
    >
      <FullRestrictionPanel disabled={disabled} state={access.isFullyRestricted()} onToggle={onFullRestrictionToggle} />
      <DetailedRestrictionPanel disabled={disabled} access={access} onSectionToggle={onSectionToggle} />
    </Stack>
  );
});

AccessManagerSettings.displayName = 'AccessManagerSettings';
